require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./courses-code-401-advanced-software-development-in-full-stack-javascript.json") })
        }
      }, "path---courses-code-401-advanced-software-development-in-full-stack-javascript");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---courses-code-401-advanced-software-development-in-full-stack-javascript!./.cache/json/courses-code-401-advanced-software-development-in-full-stack-javascript.json
// module id = 1140
// module chunks = 231608221292675